/**
 * The app's only icon primitive (WP-1): inline-SVG Material Symbols
 * (Rounded) from the self-hosted path set in icons.generated.js — crisp at
 * every devicePixelRatio, tinted via currentColor, no icon font, no CDN.
 * Decorative by default (aria-hidden): every interactive element keeps its
 * own text label or aria-label, so the icon itself never carries meaning
 * for assistive tech.
 */
import { ICON_PATHS } from './icons.generated.js';

export default function Icon({ name, size = 24, fill = false, class: className }) {
  const d = (fill && ICON_PATHS[`${name}-fill`]) || ICON_PATHS[name] || ICON_PATHS.category;
  return (
    <svg
      class={className ? `etm-icon ${className}` : 'etm-icon'}
      width={size}
      height={size}
      viewBox="0 -960 960 960"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
